export enum NoteMarkerType {
  SKILL_CHANGE = 'SKILL_CHANGE',
  INTERVENTION = 'INTERVENTION',
  LESSON_MASTERED = 'LESSON_MASTERED',
  LESSON_DISCONTINUED = 'LESSON_DISCONTINUED',
  LESSON_MAINTENANCE = 'LESSON_MAINTENANCE',
  OTHER = 'OTHER',
}
